import React from 'react'
import { Button, Icon, Input } from '@node-space/ui-components'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'
import type { FormFieldLabels } from 'pages/Contacts/types/fiatInstruments'

type AccountNumberFieldProps = {
  register: UseFormRegister<ContactFiatInstrumentFormData>
  errors: FieldErrors<ContactFiatInstrumentFormData>
  formFieldLabels: FormFieldLabels
  isBankDetailsValidationLoading: boolean
  isValidAccountNumber: boolean
  accountNumber?: string
  onBlur: () => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  wrapperProps?: Record<string, unknown>
}

export const AccountNumberField = ({
  register,
  errors,
  formFieldLabels,
  isBankDetailsValidationLoading,
  isValidAccountNumber,
  accountNumber,
  onBlur,
  onChange,
}: AccountNumberFieldProps) => {
  return (
    <Input
      {...register('accountNumber')}
      name="accountNumber"
      testId="accountNumber"
      label={formFieldLabels?.accountNumber}
      placeholder={formFieldLabels?.accountNumberPlaceholder}
      errorText={errors?.accountNumber?.message}
      error={!!errors?.accountNumber?.message}
      onBlur={onBlur}
      onChange={onChange}
      loading={isBankDetailsValidationLoading}
      IconButton={
        isValidAccountNumber && accountNumber ? (
          <Button variant="ghost" iconElement={<Icon name="Check" />} />
        ) : undefined
      }
      iconPosition="right"
    />
  )
}

